var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var startPageRouteGuard = function (props) {
    var e_1, _a;
    var _b, _c, _d, _e, _f;
    var featureGates = props.featureGates, featureSettings = props.featureSettings, path = props.path, userIdentity = props.userIdentity;
    var commercialStartPageApps = (_b = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.wacStartPageConfig) === null || _b === void 0 ? void 0 : _b.commercialStartPageApps;
    var consumerStartPageApps = (_c = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.wacStartPageConfig) === null || _c === void 0 ? void 0 : _c.consumerStartPageApps;
    var startPageApps = (userIdentity === null || userIdentity === void 0 ? void 0 : userIdentity.isMsa)
        ? (_d = consumerStartPageApps === null || consumerStartPageApps === void 0 ? void 0 : consumerStartPageApps.split(',')) !== null && _d !== void 0 ? _d : []
        : (_e = commercialStartPageApps === null || commercialStartPageApps === void 0 ? void 0 : commercialStartPageApps.split(',')) !== null && _e !== void 0 ? _e : [];
    if (((_f = featureGates === null || featureGates === void 0 ? void 0 : featureGates.wacStartPageConfigGates) === null || _f === void 0 ? void 0 : _f.wacStartPageConfigVisioStartPageEnabled) &&
        !startPageApps.includes('visio')) {
        startPageApps.push('visio');
    }
    var canActivate = startPageApps.length > 0;
    // Generate the list of start page paths the user can access.
    var supportedPaths = [];
    if (canActivate && path && typeof path === 'string') {
        try {
            for (var startPageApps_1 = __values(startPageApps), startPageApps_1_1 = startPageApps_1.next(); !startPageApps_1_1.done; startPageApps_1_1 = startPageApps_1.next()) {
                var startPageApp = startPageApps_1_1.value;
                if (startPageApp) {
                    var appPage = path.replace(':app', startPageApp);
                    supportedPaths.push(appPage);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (startPageApps_1_1 && !startPageApps_1_1.done && (_a = startPageApps_1.return)) _a.call(startPageApps_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return {
        canActivate: canActivate,
        shouldUpdatePath: canActivate,
        updatedPath: canActivate ? supportedPaths : undefined,
    };
};
//# sourceMappingURL=startPageRouteGuard.js.map